import { render, staticRenderFns } from "./PermisosTableRow.vue?vue&type=template&id=9d4e5292&scoped=true"
import script from "./PermisosTableRow.vue?vue&type=script&lang=js"
export * from "./PermisosTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4e5292",
  null
  
)

export default component.exports